import { DuckSelector, objectDuckCreator } from '@atc/modular-redux';

import { vdpDuckPreset } from '@/ducks/presets/index.js';

// TODO: combine activeEmailListing here too
export default objectDuckCreator({
    ...vdpDuckPreset,
    store: 'activeInteraction',
    initialState: {
        emailCTAContext: '',
        showAdditionalInventoryModal: false,
        showCompareModal: false,
        showFinanceAppModal: false,
        showEmailModal: false,
        showEditEmailModal: false,
        showEmailConfirmationModal: false,
        showKBBDealerModal: false,
        showModelInfoModal: false,
        showPsxExplainerContent: '',
        showAssistant: false,
    },
}).extend({
    selectors: {
        getEmailCTAContext: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).emailCTAContext),
        getShowAdditionalInventoryModal: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).showAdditionalInventoryModal),
        getShowCompareModal: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).showCompareModal),
        getShowEmailModal: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).showEmailModal),
        getShowEditEmailModal: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).showEditEmailModal),
        getShowEmailConfirmationModal: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).showEmailConfirmationModal),
        getShowFinanceAppModal: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).showFinanceAppModal),
        getShowKBBDealerModal: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).showKBBDealerModal),
        getShowModelInfoModal: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).showModelInfoModal),
        getShowPsxExplainerContent: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).showPsxExplainerContent),
        getShowAssistant: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).showAssistant),
    },
});
